const {UNKNOWN_CURRENCY_ERROR} = require("./initRequest");

let errorDom;

function showError(errorCode) {
	if (!errorDom) {
		initError();
	}

	errorDom.innerHTML = getErrorTextByCode(errorCode);

	const prt = document.getElementById("error-message");
	const ldr = document.getElementById("loader-wrapper");

	prt.style.display = "block";
	ldr.style.display = "block";
}

function getErrorTextByCode(errorCode) {
	switch (errorCode) {
		case UNKNOWN_CURRENCY_ERROR:
			return `Oops! Looks like this game isn’t available in your region or currency yet.`;
		default:
			return errorCode;
	}
}

function initError() {
	const docuElement = document.getElementById("game-content");

	docuElement.innerHTML = `${""
	+ "<div id=\"loader-wrapper\">"
	+ "   <div id=\"error-message\">"
	+ "       <div class=\"error-title\"></div>"
	+ "       <div class=\"error-text\"></div>"
	+ "   </div>"
	+ "</div>"
	+ "\n"}${document.body.innerHTML}`;

	document.getElementsByClassName("error-title")[0].innerHTML = "Error";
	errorDom = document.getElementsByClassName("error-text")[0];
}

module.exports = {showError};


// WEBPACK FOOTER //
// ./js/ErrorOverlay.js